import { useBannedIPsQuery } from "@sso/apis/BannedIP";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectBannedIPQuery } from "@sso/store/slices/bannedIP";

export const useGetBannedIPsQuery = () => {
  const queryParams = useAppSelector(selectBannedIPQuery);
  return useBannedIPsQuery(queryParams);
};
